import $ from 'jquery';
const lazyload = require( 'lazyload' );
import '/javascripts/loader.min';
import '/node_modules/bootstrap/dist/js/bootstrap.esm.min';
import '/assets/plugins/jquery-ui/v1.13.0/js/jquery.ui.min';
import '/assets/plugins/jquery/unveil/jquery.unveil.min';
import '/assets/plugins/bootstrap-collapse/bootstrap-tabcollapse';
import '/assets/pages/js/pages.min';
import '/assets/pages/frontend/pages.frontend.min';
import '/assets/js/builder.min';
import '/assets/js/builder-float-button.min';

export default function IndexScripts () {
  return (
    <>
    </>
  )
}
